import { Suspense } from 'react'
import { ErrorBoundary } from '@sentry/react'

import { DownloadPage } from '@jotta/ui/DownloadPage'
import { ErrorPage } from '@jotta/ui/ErrorPage'
import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'

import { PublicLayout } from '../components/Layout/PublicLayout'

export const DownloadPageRoute = () => {
  return (
    <PublicLayout section="download">
      <ErrorBoundary
        fallback={({ error, resetError }) => (
          <ErrorPage error={error} resetError={resetError} hideFooter />
        )}
      >
        <Suspense fallback={<LoadingOverlay id="DownloadPageRoute" open />}>
          <DownloadPage />
        </Suspense>
      </ErrorBoundary>
    </PublicLayout>
  )
}
